import React, { useEffect } from "react";
import styles from "./styles.css";
import IconOne from "../../shared/images/icon-solution-1.png";
import IconTwo from "../../shared/images/icon-solution-2.png";
import IconThree from "../../shared/images/icon-solution-3.png";
import IconFour from "../../shared/images/icon-solution-4.png";
import IconFive from "../../shared/images/icon-solution-5.png";
import IconSix from "../../shared/images/icon-solution-6.png";
import IconSeven from "../../shared/images/icon-solution-7.png";
import IconEight from "../../shared/images/icon-solution-8.png";
import IconUserOne from "../../shared/images/user.jpg";
import IconUserTwo from "../../shared/images/user-1.jpg";
import IconUserThree from "../../shared/images/user-2.jpg";
import IconUserFour from "../../shared/images/user-3.jpg";
import Slider from "../../shared/slick-wrapper";
import WhiteCard from "../../shared/white-card";
import Button from "../../shared/button";
import BecomeOurPartnerForm from "../../desktop/become-our-partner-form";
import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import useToggle from "../../../hooks/use-toggle";
import PropTypes from "prop-types";

const BecomeOurPartnerInfo = ({
    storeCount,
    cityCount,
    resetPartnerSelectionsConnect,
    setNameConnect,
    setMobileConnect,
    setEmailConnect
}) => {
    const [isOpen, setIsOpen] = useToggle();
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow: true
    };

    /**
     * reset form if opened in modal
     */
    useEffect(() => {
        if (isOpen) {
            resetPartnerSelectionsConnect();
            setNameConnect("");
            setMobileConnect("");
            setEmailConnect("");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    return (
        <React.Fragment>
            <div styleName={"styles.heroBanner"}>
                <div className="container" >
                    <div className="row">
                        <div className="col-6" styleName={"styles.heading"}>
                            <div styleName={"styles.dealersIntro"}>
                                <h1>Car Khareedo <br/>Bharose Ke Saath</h1>
                                <p>Become our partner and give <br/>a boost to your business!</p>
                            </div>
                        </div>
                        <div className="col-6">
                            <BecomeOurPartnerForm
                                onPincodeMenuOpen={
                                    ({overrideMenuFocus}) => overrideMenuFocus(true)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div styleName={"styles.dealerFeature"}>
                                <h4>Wide Assortment of <br/> Cars</h4>
                                <p>Choose from the largest pool of used cars in the country.</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.dealerFeature"}>
                                <h4>Verified Cars with Paperwork</h4>
                                <p>All cars are verified with complete paperwork by
                                    our team of experts.</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.dealerFeature"}>
                                <h4>Trusted Inspection Reports</h4>
                                <p>The detailed report made available before bidding.</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.dealerFeature styles.dealerLast"}>
                                <h4>Transparent Bidding Process</h4>
                                <p>We ensure a fair &amp; easy bidding process.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div styleName={"styles.completeSolution"}>
                <div className="container">
                    <h2 styleName={"styles.dealerTitle"}>We help you with a complete solution</h2>
                    <div className="row">
                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconOne} alt="Designated Account Manager" />
                                </span>
                                <h4>Designated <br/>Account Manager</h4>

                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconTwo} alt="Amazing Reward Schemes" />
                                </span>
                                <h4>Amazing Reward <br/> Schemes</h4>
                            </div>
                        </div>

                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconThree} alt="Amazing Reward Schemes" />
                                </span>
                                <h4>Hassle Free Payment <br/> & Delivery Process</h4>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconFour} alt="Amazing Reward Schemes" />
                                </span>
                                <h4>Home Delivery of <br/>  Cars & Documents</h4>
                            </div>
                        </div>

                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconFive} alt="Sell Cars via Auction24" />
                                </span>
                                <h4>Platform to<br/>Sell Cars</h4>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>

                                    <img src={IconSix} alt="No Limit on Bidding in Car Auctions" />
                                </span>
                                <h4>No Limit on Bidding <br/> in Car Auctions</h4>
                            </div>
                        </div>

                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>
                                    <img src={IconSeven} alt="RC Transfer Support" />
                                </span>
                                <h4>RC Transfer<br/>Support</h4>
                            </div>
                        </div>
                        <div className="col-3">
                            <div styleName={"styles.solutionBox"}>
                                <span styleName={"styles.icon"}>

                                    <img src={IconEight} alt="Unnati Fianancing Options" />
                                </span>
                                <h4>Unnati Financing <br/>Options</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div styleName={"styles.dealerPartner"}>
                <div className="container">
                    <h2 styleName={"styles.dealerTitle"}>Hear from our partners</h2>
                    <div styleName={"styles.becomeOurPatnerSliders"}>
                        <Slider {...settings}>
                            <WhiteCard>
                                <div styleName={"styles.sliderBox"}>
                                    <span styleName={"styles.partnerImage"}>
                                        <img src={IconUserOne} alt="Partner Image"/>
                                    </span>
                                    <p styleName={"styles.partnerText"}>
                                        The Unnati Funding  Programme of Cars24 helped
                                        immensely to increase my business. In the last 2 years,
                                        I have witnessed a monumental growth of 200%. The best part
                                        about it was easy documentation and 0% investment
                                         required to avail the benefits.
                                    </p>
                                    <h5 styleName={"styles.partnerName"}>
                                        Superior Motors, Bangalore</h5>
                                </div>
                            </WhiteCard>
                            <WhiteCard>
                                <div styleName={"styles.sliderBox"}>
                                    <span styleName={"styles.partnerImage"}>
                                        <img src={IconUserTwo} alt="Partner Image"/>
                                    </span>
                                    <p styleName={"styles.partnerText"}>
                                        Cars24 has procured quality cars for our business and showed
                                        excellent level of service. Deliveries are always on the dot
                                        and the turn around time to resolve an issue is impressive.
                                        Professional demeanour, attention to details during car
                                        inspection, and adept post-sale services is what sets
                                        Cars24 apart.
                                    </p>
                                    <h5 styleName={"styles.partnerName"}>
                                    MFC, Auto Trade, Pune</h5>
                                </div>
                            </WhiteCard>
                            <WhiteCard>
                                <div styleName={"styles.sliderBox"}>
                                    <span styleName={"styles.partnerImage"}>
                                        <img src={IconUserThree} alt="Partner Image"/>
                                    </span>
                                    <p styleName={"styles.partnerText"}>
                                        The best aspect about Cars24 is the smooth process
                                        they follow - starting from the inspection procedure
                                        to the delivery of cars. I laud the excellent wide
                                        variety of services that Cars24 has to offer,
                                        ensuring growth of our business. The amicable
                                        company employees are always responsive and
                                        willing to serve in the best way possible.
                                    </p>
                                    <h5 styleName={"styles.partnerName"}>
                                    SUB5 CARS, Hyderabad</h5>
                                </div>
                            </WhiteCard>
                            <WhiteCard>
                                <div styleName={"styles.sliderBox"}>
                                    <span styleName={"styles.partnerImage"}>
                                        <img src={IconUserFour} alt="Partner Image"/>
                                    </span>
                                    <p styleName={"styles.partnerText"}>
                                        Cars24 for the success of my business - the size of
                                        my counter has just doubled. Now, I have access to
                                        over 150 cars daily from across India. Procurement
                                        of cars from my counter has become all the more
                                        convenient and hassle-free. The increase in efficiency
                                        has increased our ability to sell more and more cars,
                                        in a jiffy!

                                    </p>
                                    <h5 styleName={"styles.partnerName"}>
                                    Sakthi Cars, Chennai</h5>
                                </div>
                            </WhiteCard>

                        </Slider>
                    </div>
                </div>
            </div>
            <div styleName={"styles.dealerSuccess"}>
                <div className="container">
                    <div className="row">
                        <div className="col-4">
                            <h3>The Success <br/>of Cars24</h3>
                        </div>
                        <div className="col-8">
                            <ul>
                                <li>
                                    <h4>4,000+</h4>
                                    <p>Channel partners</p>
                                </li>
                                <li>
                                    <h4>50,000+</h4>
                                    <p>Cars sold in last 1 year</p>
                                </li>
                                <li>
                                    <h4>{storeCount}+</h4>
                                    <p>Branches in {cityCount} cities</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div styleName={"styles.dealerFooter"}>
                <div className="container">
                    <h2>Car Khareedo Bharose Ke Saath</h2>
                    <p>Become our partner and give a boost to <br/>your business!</p>
                    <Modal isOpen={isOpen}
                        contentClass="drsLoader" >
                        <div styleName={"styles.popUpWrap"}>
                            <BecomeOurPartnerForm
                                onPincodeMenuOpen={
                                    ({overrideMenuFocus}) => overrideMenuFocus(true)}
                            />
                            <span
                                onClick={setIsOpen}
                                styleName={"styles.close"}
                            >
                                <CloseButton
                                    type="grey" />
                            </span>
                        </div>
                    </Modal>
                    <Button
                        onClick={setIsOpen}
                        text="Get Started"/>
                </div>
            </div>
        </React.Fragment>
    );

};

BecomeOurPartnerInfo.propTypes = {
    storeCount: PropTypes.number,
    cityCount: PropTypes.number,
    resetPartnerSelectionsConnect: PropTypes.func,
    setNameConnect: PropTypes.func,
    setMobileConnect: PropTypes.func,
    setEmailConnect: PropTypes.func
};

export default BecomeOurPartnerInfo;
